// eslint-disable-next-line import/no-cycle
import feathersClient from "../../feathers-client";

const defaultPrivacyPolicyPagination = {
	total: 100,
	skip: 0,
	limit: 7,
};

const defaultPrivacyPolicyLogsFilter = {
	skip: defaultPrivacyPolicyPagination.skip,
	limit: defaultPrivacyPolicyPagination.limit,
};

export default {
	state: {
		privacyPolicyLogs: [],
		privacypolicylogsFilter: defaultPrivacyPolicyLogsFilter,
		privacyPolicyLogsPagination: defaultPrivacyPolicyPagination,
	},
	getters: {
		privacyPolicyLogs: (state) => state.privacyPolicyLogs,
		privacyPolicyLogsPage: (state) => {
			const { limit, skip } = state.privacyPolicyLogsPagination;
			return skip / limit + 1;
		},
	},
	mutations: {
		SET_PRIVACYPOLICY_LOGS: (state, privacyPolicyLogs) => {
			state.privacyPolicyLogs = [...privacyPolicyLogs];
		},
		SET_PRIVACYPOLICY_LOGS_FILTER: (state, filter) => {
			state.privacypolicylogsFilter = {
				...state.privacypolicylogsFilter,
				...filter,
			};
		},
		SET_DEFAULT_PRIVACYPOLICY_LOGS_FILTER: (state, filter) => {
			state.privacypolicylogsFilter = {
				...filter,
				...defaultPrivacyPolicyLogsFilter,
			};
		},
		SET_PRIVACYPOLICY_LOGS_PAGINATION: (state, data) => {
			state.privacyPolicyLogsPagination = {
				...state.privacyPolicyLogsPagination,
				...data,
			};
		},
	},
	actions: {
		setPrivacyPolicyLogsPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.privacyPolicyLogsPagination.limit;
			commit('SET_PRIVACYPOLICY_LOGS_PAGINATION', { skip });
			commit('SET_PRIVACYPOLICY_LOGS_FILTER', { skip });
		},
		setDefaultPrivacyPolicyLogsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_PRIVACYPOLICY_LOGS_FILTER', filter);
		},
		loadPrivacypolicyLogs: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/privacypolicylogs';
			const filterCount = { $skip: filter.skip, $limit: filter.limit }; // super-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...filterCount } });
			commit('SET_PRIVACYPOLICY_LOGS', results.data);
			const totalCount = results.total;
			commit('SET_PRIVACYPOLICY_LOGS_PAGINATION', { total: totalCount });
			return results;
		},
		setPrivacyPolicyLogsFilter: ({ commit }, filter) => {
			commit('SET_PRIVACYPOLICY_LOGS_FILTER', filter);
		},
		updatePrivacyPolicies: async ({ rootGetters }, privacyPolicy) => {
			const url = '/api/v3/privacypolicies'; // super-admin
			const results = await feathersClient.service(url).patch(privacyPolicy.id, privacyPolicy, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		createPrivacyPolicies: async ({ rootGetters }, privacyPolicy) => {
			const url = '/api/v3/privacypolicies'; // super-addmin
			const results = await feathersClient.service(url).create(privacyPolicy, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getPrivacyPolicy: async () => {
			const url = '/api/v3/privacypolicies';
			const results = await await feathersClient.service(url).find({});
			return results;
		},
	},
};
